const wowApp = require('angular').module('wowApp.shop');

wowApp.service('PasswordValidationService', ['$q', 'SettingsService', require('./password-validation-service')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/password-validation/index.js
 **/